import React, { useCallback, useEffect, useState } from 'react'
// import { useHistory } from 'react-router-dom'
import { Collapse } from '@material-ui/core'
import { Form } from '@unform/web'
// import Button from '../../components/Button'
import Header from '../../components/Header'
import { Content } from './styles'
import Container from '../../components/Container'
import Input from '../../components/Input'

const Authenticate: React.FC = () => {
  const [isOpenAuthPortal, setIsOpenAuthPortal] = useState(false)
  const [isOpenAuthFederation, setIsOpenAuthFederation] = useState(false)
  // const history = useHistory()

  const handlePortal = useCallback(async () => {
    setIsOpenAuthPortal(true)
    setIsOpenAuthFederation(false)
  }, [])

  const handleFederation = useCallback(async () => {
    setIsOpenAuthPortal(false)
    setIsOpenAuthFederation(true)
  }, [])

  const onSubmitAuthPortal = useCallback(async data => {
    // eslint-disable-next-line no-console
    console.log(data)
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <p>Antes de iniciar, precisamos que você faça sua autenticação</p>
          <div>
            <button type="button" onClick={handlePortal}>
              Autenticar com Portal do Participante
            </button>
            <Collapse in={isOpenAuthPortal}>
              <Form onSubmit={onSubmitAuthPortal}>
                <Input name="usuario" placeholder="Usuário" />
                <Input name="senha" placeholder="Senha" />
              </Form>
            </Collapse>
          </div>
          <div>
            <button type="button" onClick={handleFederation}>
              Autenticar com Federation
            </button>
            <Collapse in={isOpenAuthFederation}>oi</Collapse>
          </div>

          {/* <Button
            color="orange"
            onClick={handleAccession}
            width="large"
            fontSize="large"
          >
            Fazer adesão
          </Button>
          <br />
          <br />
          <p>Ou deseja começar a adesão fazendo uma simulação?</p>
          <Button
            color="orange"
            onClick={handleSimulation}
            width="large"
            fontSize="large"
          >
            Sim, quero simular
          </Button> */}
        </Content>
      </Container>
    </>
  )
}

export default Authenticate
